export default "__VITE_ASSET__Bg1xFH9N__"